import {useEffect, useRef} from 'react';
import {getRealtimeMessages, approveSystemMessage} from '../../../../../redux/realtime/realtimeActions';
import {useSelector} from 'react-redux';
import * as css from './systemMessage.css';
import {useTranslation} from 'react-i18next';
import Btn from '../../../../../component/button/btn/Btn';
import {Link} from 'react-router-dom';
import {TSystemMessage} from '../../../../../redux/realtime/realtime.type';
import {useSystemMessageFilter} from './useSystemMessageFilter';
import CustomScrollbar from '../../../../../component/customScrollbar/CustomScrollbar';
import useMobile from '../../../../../hooks/useMobile';
function SystemMessage({isPop=false, close, message, skipFilter=false}:{isPop:boolean, close?: any, message: TSystemMessage, skipFilter?: boolean}){
    const systemMessageXHR = useSelector((s:any) => s.realtime.getSystemMessageXHR);
    const eid = useSelector((s:any) => s.event?.eid);
    const {t} = useTranslation('realtime');
    const shouldDisplay = useSystemMessageFilter(message);
    const messageRef = useRef(null);
    const isMobile = useMobile();

    useEffect(()=>{
        if(!systemMessageXHR && eid)
            getRealtimeMessages().then();
    },[]);

    const approve = (event) => {
        event.preventDefault();// Prevent the default action of the link

        // Send Google Analytics event for button click
        if(isPop){
            if(typeof (window as any)?.gtag === 'function') {
                (window as any).gtag('event', 'button_click', {
                    button_name: 'approve_system_message',
                    event_category: 'user_interaction',
                    event_label: 'message id: ' + message.smid
                });
            }
        }

        approveSystemMessage(message.smid);
        if(close)
            close();
    };
    useEffect(() => {
        if(isPop){
            if(typeof (window as any)?.gtag === 'function') {
                (window as any).gtag('event', 'popup_opened', {
                    popup_name: 'systemMessage',
                    popup_title: t('systemMessage'),
                    page_title: 'system message - הודעת מערכת',
                    event_label: 'message id: ' + message.smid
                });
            }
        }
    }, [message?.smid]);
    const btnApproved=()=>!!(isPop && message.watchRequired )&&<Btn onClick={approve} className={'white'} disabled={undefined} ><css.approved/>{t('approveView')}</Btn>;
    const isImageAndText = message.formType === 'imageAndText';
    const containerImage = !isPop && !isImageAndText && message.image ? message.image : undefined;

    if(!skipFilter && !shouldDisplay) {
        return <></>;
    }

    return (
        message?.status?
            message.title? <css.container  image={containerImage} >
                {isPop && !isMobile && <CustomScrollbar contentRef={messageRef} cssStyle={''} />}
                <css.contentWrapper ref={messageRef}>
                    {isImageAndText && message.image && <css.imageContent image={message.image} />}
                    {!isPop && <css.title>{message.title}</css.title>}
                    <css.message><p>{message.message}</p></css.message>
                </css.contentWrapper>
                <css.buttons>
                    {message.link && <Btn target='_blank' href={message.link} className={'yellow'} onClick={undefined} disabled={undefined} >{message.linkText || t('showMe')}</Btn>}
                    {btnApproved()}
                </css.buttons>
            </css.container>
                :
                <css.container className='no-title' image={containerImage} >
                    {isImageAndText && message.image && <css.imageContent image={message.image} />}
                    <Link to={message.link} target='_blank'>
                        {btnApproved()}
                    </Link>
                </css.container>

            :<></>
    );
}

export default SystemMessage;
